import React from 'react'

const ProjectsHeader = ({ title, subtitle }) => {
  return (
    <div className='flex flex-col mt-5 mb-5 mx-auto max-w-2xl justify-center items-center text-center text-dark-accent dark:text-light-accent2'>
      <h1 className='text-3xl font-bold m-2'>
        {title}
      </h1>
      <p className='m-2 text-lg'>
        {subtitle}
      </p>
    </div>
  )
}

export default ProjectsHeader